// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a60380d1","455":"e5777cf5","977":"f105d86a"}[chunkId] + ".chunk.js";
};